const CLEAR_FORM_ELEMENTS = 'fulcrum/ProjectOverview/CLEAR_FORM_ELEMENTS'
const COPY_FORM_ELEMENTS = 'fulcrum/ProjectOverview/COPY_FORM_ELEMENTS'
const LOAD_FORM_DATA = 'fulcrum/ProjectOverview/LOAD_FORM_DATA'

/* Form */
const LOAD_REVISION = 'fulcrum/container/Form/LOAD_REVISION'
const LOAD_REVISION_SUCCESS = 'fulcrum/container/Form/LOAD_REVISION_SUCCESS'
const LOAD_REVISION_ERROR = 'fulcrum/container/Form/LOAD_REVISION_ERROR'

export {
  CLEAR_FORM_ELEMENTS,
  COPY_FORM_ELEMENTS,
  LOAD_FORM_DATA,
  LOAD_REVISION,
  LOAD_REVISION_SUCCESS,
  LOAD_REVISION_ERROR,
}
